
	import { defineComponent } from 'vue'
	import KnHint from '@/components/UI/KnHint.vue'

	export default defineComponent({
		name: 'import-export-hint',
		components: { KnHint }
	})
